export default ({ app }) => {
  return app.$user.onAuthStateChanged()
}
